import { Signal } from 'framework/utils/Signal';
import { KeyCode } from 'framework/Keyboard/KeyCodes';
import OS from 'framework/utils/OS';

const availableLetters = [
  'Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P',
  'A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L',
  'Z', 'X', 'C', 'V', 'B', 'N', 'M',
];

const deletingKeys = ['Backspace', 'Delete'];

const arrows = [KeyCode.UP, KeyCode.DOWN, KeyCode.LEFT, KeyCode.RIGHT];

export class KeyboardInputCatcher {
  public onLetterPressed: Signal<string> = new Signal();
  public onBackspacePressed: Signal<void> = new Signal();
  public onArrowPressed: Signal<KeyCode> = new Signal();
  public onSpacebarPressed: Signal<void> = new Signal();
  public onEnterPressed: Signal<void> = new Signal();
  public onShiftEnterPressed: Signal<void> = new Signal();
  public onTabPressed: Signal<void> = new Signal();
  public onShiftTabPressed: Signal<void> = new Signal();

  constructor() {
    if (OS.android) this.initAndroidKeydownWorkaround();
    window.addEventListener('keydown', this.processKeyDown, true);
  }

  private initAndroidKeydownWorkaround(): void {
    const mobileInput = document.getElementById('mobileTextInput')! as HTMLInputElement;
    mobileInput.value = '#';
    let lastFieldValue = mobileInput.value;
    mobileInput.addEventListener('keyup', () => {
      const fieldValue = mobileInput.value;
      if (fieldValue.length < lastFieldValue.length || fieldValue.length === 0) {
        this.onBackspacePressed.dispatch();
      } else if (fieldValue.length > lastFieldValue.length) {
        const enteredChar = fieldValue[fieldValue.length - 1].toUpperCase();
        if (availableLetters.includes(enteredChar)) this.onLetterPressed.dispatch(enteredChar);
        if (enteredChar === ' ') this.onSpacebarPressed.dispatch();
      }
      lastFieldValue = fieldValue;
    });
  }

  public processKeyDown = (event: KeyboardEvent) => {
    if (event.target && (event.target.nodeName === 'TEXTAREA' || event.target.nodeName ==='INPUT') && event.target.id !== 'mobileTextInput') return;

    if (availableLetters.includes(event.key.toUpperCase())) {
      this.onLetterPressed.dispatch(event.key.toUpperCase());
      event.preventDefault();
      return;
    }

    if (deletingKeys.includes(event.key)) {
      this.onBackspacePressed.dispatch();
      event.preventDefault();
    }

    if (arrows.includes(event.keyCode)) {
      this.onArrowPressed.dispatch(event.keyCode);
      event.preventDefault();
    }

    if (event.keyCode === KeyCode.SPACEBAR) {
      this.onSpacebarPressed.dispatch();
      event.preventDefault();
    }

    if (event.keyCode === KeyCode.TAB) {
      const signal = event.shiftKey ? this.onShiftTabPressed : this.onTabPressed;
      signal.dispatch();
      event.preventDefault();
    }

    if (
      event.keyCode === KeyCode.ENTER ||
      event.keyCode === KeyCode.NUMPAD_ENTER
    ) {
      const signal = event.shiftKey ? this.onShiftEnterPressed : this.onEnterPressed;
      signal.dispatch();
      event.preventDefault();
    }
  };

  public destroy(): void {
    window.removeEventListener('keydown', this.processKeyDown, true);
  }
}
